import { Link, useLocation } from "react-router-dom";
import ThemeModeProvider from "../theme-mode/ThemeModeProvider";
import SearchBar from "../search/SearchBar";
import { useEffect, useState } from "react";
//import AclRequired from "../acl/AclRequired";
import logo from '../../assets/media/logos/fiducia/favicon/favicon-48x48.png';
export function TitleHeader(){

    const {pathname} = useLocation();
    const titulo = pathname.split("/")[1].toUpperCase();
    const [history, setHistory] = useState([]);

    ////////////////////////// Breadcrumb ////////////////////////////
    useEffect(() => {

        const newpath = pathname.replace('/', '');
        const exist = history.some(h => h.slice(0,  h.indexOf('/')) === newpath.slice(0,  newpath.indexOf('/')) );
        if (!exist){
            if (history.length < 3){
                setHistory([...history, newpath]); //
            } else {
                setHistory(prevState => prevState.slice(1));
            }
        }

    }, [pathname, history]);


    /////////// Subtitulo del heaader ///////////

    return(
        <>
            <div className="page-title d-flex flex-column align-items-start justify-content-center flex-wrap mt-n5 mt-lg-0 me-lg-2 pb-2 pb-lg-0"> {/* style={{order: -1}} */}
                <h1 className="text-gray-900 fw-bold my-0 fs-2">
                    {titulo.replaceAll("-", ' ')}
                </h1>
                <ul className="breadcrumb fw-semibold fs-base my-1">
                    {
                        history && history.map((h) => {
                            return (
                                <li key={h} className="breadcrumb-item">
                                    <Link
                                        to={'/' + h}
                                        className={'text-capitalize ' + (h === pathname.replace('/','') ? "text-primary" : "text-muted text-hover-primary")}>
                                        {h.slice(0,  h.indexOf('/'))}
                                    </Link>
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        </>
    );
}

export default function HeaderPage({
   handleChangeTheme,
   setNavSm,
}) {
    // URL de la ubicación actual para sacar el título
    const {pathname} = useLocation();

    useEffect(() => {
        const body = document.body;
        pathname === "/content" && body.setAttribute("data-kt-aside-minimize", "on");
    }, [pathname]);

    return (
        <>
            <div className="header"
                 style={{backgroundColor: "var(--bs-page-bg)",
                     position: "sticky",
                     top: 0,
                     boxShadow: "rgba(82, 63, 105, 0.08) 0px 10px 30px 0px",
                     zIndex: 10}}
            >
                <div className="container-fluid d-flex align-items-center justify-content-between"
                     id="header_container">
                    <div className="d-flex d-lg-none align-items-center me-2">
                        <div className="btn btn-icon btn-active-icon-primary me-2" onClick={() => setNavSm(true)}>
                            <i id="kt_aside_mobile_toggle" className="ki-solid ki-abstract-14 fs-1"></i>
                        </div>
                        <Link to={"/dashboard"}>
                            <img alt="Logo" src={logo} className="h-30px"/>
                        </Link>
                    </div>
                    <TitleHeader></TitleHeader>
                    <div className="d-flex">
                        {/*flex-shrink-0*/}
                        <div className="d-flex align-items-center ms-3">
                            {/*<AclRequired allowedRoles={["FINDER", "/camelus/finder"]}>*/}
                                <SearchBar></SearchBar>
                            {/*</AclRequired>*/}
                            <ThemeModeProvider handleChangeTheme={handleChangeTheme}></ThemeModeProvider>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
